import React, { useCallback, useState } from 'react'
import PageBanner from 'LuxKit/Banners/PageBanner'
import { getDismissed, setDismissed as sessionSetDismissed } from 'luxPlus/storage/renewalBanner'
import useRenewalAction from 'luxPlus/hooks/useRenewalAction'
import { LUXURY_PLUS, LUXURY_PLUS_PATHS } from 'luxPlus/constants/base'
import { useAppSelector } from 'hooks/reduxHooks'
import getIsLoyaltyLuxPlusRenewalBonusEnabled from 'loyalty/selectors/getIsLoyaltyLuxPlusRenewalBonusEnabled'
import FormatLoyaltyStatusCredits from 'loyalty/components/Formatters/FormatLoyaltyStatusCredits'
import FormatLoyaltyBonusPoints from 'loyalty/components/Formatters/FormatLoyaltyBonusPoints'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'
import { LOYALTY_LUX_PLUS_RENEWAL_BONUS_STATUS_CREDITS, LOYALTY_LUX_PLUS_RENEWAL_BONUS_POINTS } from 'loyalty/constants/loyaltyBonusPoints'

function LuxPlusRenewalBanner() {
  const [dismissed, setDismissed] = useState(getDismissed())
  const handleRenewal = useRenewalAction()
  const isLoyaltyLuxPlusRenewalBonusEnabled = useAppSelector(getIsLoyaltyLuxPlusRenewalBonusEnabled)

  const renewalStatus = useAppSelector(state => state.auth.account.luxPlus.member.subscription.item?.renewalStatus)
  const hasAutoRenewal = renewalStatus === 'ALLOW_RENEWAL'

  const dismiss = useCallback(() => {
    setDismissed(true)
    sessionSetDismissed()
  }, [])

  if (dismissed) return null

  return <PageBanner
    kind="critical"
    onDismiss={dismiss}
    primaryActionButtonProps={{
      onClick: handleRenewal,
      children: 'Renew now',
    }}
    secondaryActionButtonProps={{
      to: `/${LUXURY_PLUS_PATHS.ACCOUNT_MANAGEMENT_PAGE}`,
      children: 'Manage membership',
    }}
    description={<>
      {hasAutoRenewal && <b>Your {LUXURY_PLUS.PROGRAM_NAME} Membership failed to renew due to to a payment issue.{' '}</b>}
      {!hasAutoRenewal && <b>Your {LUXURY_PLUS.PROGRAM_NAME} Membership will expire soon.{' '}</b>}
      {isLoyaltyLuxPlusRenewalBonusEnabled && <>Renew now to receive <b><FormatLoyaltyStatusCredits statusCredits={LOYALTY_LUX_PLUS_RENEWAL_BONUS_STATUS_CREDITS} /> and <FormatLoyaltyBonusPoints points={LOYALTY_LUX_PLUS_RENEWAL_BONUS_POINTS} /></b> with {getLoyaltyProgramDisplayName()}.</>}
      {!isLoyaltyLuxPlusRenewalBonusEnabled && <>Your benefits are on hold until payment is completed.</>}
    </>}
  />
}

export default LuxPlusRenewalBanner
